module.exports = __webpack_public_path__ + "media/left.7b310943.mp3";